import React, {useRef, useState} from "react";
import {
    Container,
    CalcFormCenter,
    CalcSection,
    CalcFieldRow,
    CalcLabel,
    CalcInputWrap,
    CalcButtonWrap,
    CalcResultBox,
    CalcDivider,
    calcPrimaryButtonStyle,
} from "./styles";
import InputMask from "../../../components/Form/InputMask";
import {currencyFormat} from "../../../utils/masks";
import {InputAdornment} from "@material-ui/core";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import * as Yup from "yup";
import messageTypes from "../../../constants/MessagesTypes";
import CustomButton from "../../../components/Form/Button";
import {Form} from "@unform/web";
import {useTranslation} from "react-i18next";
import {FormWrapper} from "../../../styles/listPageTheme";

export default function Porcentagem() {
    const { coinType} = useSelector((state) => state.BankReducer);
    const formRef1 = useRef(null);
    const formRef2 = useRef(null);
    const { t } = useTranslation();
    const [resultCalc1, setResultCalc1] = useState(null);
    const [resultCalc2, setResultCalc2] = useState(null);

    async function handleSubmitCalc1(data) {
        try {

            formRef1.current.setErrors({});
            const schema = Yup.object().shape({
                value: Yup.string().required(t('input_required')),
                valuePercent: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            const value = parseFloat(data.value.replace(/[^0-9,-]*/g, '').replace(',', '.'));
            const valuePercent = parseFloat(data.valuePercent);
            if (!parseInt(value) || !parseInt(valuePercent)) {
                toast.warning(t('calc_invalid_values'));
                return;
            }

            const result = (valuePercent / 100) * value;
            setResultCalc1(currencyFormat(result));

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef1.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    async function handleSubmitCalc2(data) {
        try {

            formRef2.current.setErrors({});
            const schema = Yup.object().shape({
                value: Yup.string().required(t('input_required')),
                total: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            const value = parseFloat(data.value.replace(/[^0-9,-]*/g, '').replace(',', '.'));
            const total = parseFloat(data.total);
            if (!parseInt(value) || !parseInt(total)) {
                toast.warning(t('calc_invalid_values'));
                return;
            }

            let result = (value / total) * 100;
            setResultCalc2(result);

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef2.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    const buttonHoverIn = (e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.45)';
    };
    const buttonHoverOut = (e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = calcPrimaryButtonStyle.boxShadow;
    };

    return (
        <Container>
            <CalcFormCenter>
            <FormWrapper>
                <Form ref={formRef1} onSubmit={handleSubmitCalc1}>
                    <CalcSection>
                        <CalcFieldRow>
                            <CalcLabel>{t('calc_percent_what_is')}</CalcLabel>
                            <CalcInputWrap $variant="percent">
                                <InputMask
                                    size="small"
                                    type="text"
                                    name="valuePercent"
                                    placeholder="0"
                                    label=" "
                                    mask={'percent'}
                                    InputProps={{
                                        endAdornment: <InputAdornment position={'end'}>%</InputAdornment>,
                                    }}
                                />
                            </CalcInputWrap>
                            <CalcLabel>{t('calc_percent_of')}</CalcLabel>
                            <CalcInputWrap $variant="currency">
                                <InputMask
                                    size="small"
                                    type="text"
                                    name="value"
                                    placeholder="0"
                                    label=" "
                                    mask={'currency'}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">{coinType}</InputAdornment>,
                                    }}
                                />
                            </CalcInputWrap>
                            <CalcButtonWrap>
                                <CustomButton
                                    type="submit"
                                    style={calcPrimaryButtonStyle}
                                    onMouseEnter={buttonHoverIn}
                                    onMouseLeave={buttonHoverOut}
                                >
                                    {t('calc_btn_calculate')}
                                </CustomButton>
                            </CalcButtonWrap>
                        </CalcFieldRow>
                        <CalcResultBox>
                            <span className="calc-result-label">{t('calc_result')}</span>
                            <div
                                className={`calc-result-value${resultCalc1 ? '' : ' is-placeholder'}`}
                            >
                                {resultCalc1 ? `${coinType} ${resultCalc1}` : '—'}
                            </div>
                        </CalcResultBox>
                    </CalcSection>
                </Form>
            </FormWrapper>
            </CalcFormCenter>

            <CalcDivider/>

            <CalcFormCenter>
            <FormWrapper>
                <Form ref={formRef2} onSubmit={handleSubmitCalc2}>
                    <CalcSection>
                        <CalcFieldRow $nowrap>
                            <CalcLabel $nowrap>{t('calc_percent_value_label')}</CalcLabel>
                            <CalcInputWrap $variant="currency" $compact>
                                <InputMask
                                    size="small"
                                    type="text"
                                    name="value"
                                    placeholder="0"
                                    label=" "
                                    mask={'currency'}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">{coinType}</InputAdornment>,
                                    }}
                                />
                            </CalcInputWrap>
                            <CalcLabel $nowrap>{t('calc_percent_is_what_of')}</CalcLabel>
                            <CalcInputWrap $variant="currency" $compact>
                                <InputMask
                                    size="small"
                                    type="text"
                                    name="total"
                                    placeholder="0"
                                    label=" "
                                    mask={'currency'}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">{coinType}</InputAdornment>,
                                    }}
                                />
                            </CalcInputWrap>
                            <CalcButtonWrap>
                                <CustomButton
                                    type="submit"
                                    style={calcPrimaryButtonStyle}
                                    onMouseEnter={buttonHoverIn}
                                    onMouseLeave={buttonHoverOut}
                                >
                                    {t('calc_btn_calculate')}
                                </CustomButton>
                            </CalcButtonWrap>
                        </CalcFieldRow>
                        <CalcResultBox>
                            <span className="calc-result-label">{t('calc_result')}</span>
                            <div
                                className={`calc-result-value${resultCalc2 != null ? '' : ' is-placeholder'}`}
                            >
                                {resultCalc2 != null ? `${Number(resultCalc2).toFixed(2)}%` : '—'}
                            </div>
                        </CalcResultBox>
                    </CalcSection>
                </Form>
            </FormWrapper>
            </CalcFormCenter>
        </Container>
    );
}
